import React, { useState, useEffect } from "react";
import "./RollingText1.css"; // Import your stylesheet here

const RollingText1 = () => {
  const texts = ["Connection", "Closure", "Perspective"];
  const [currentText, setCurrentText] = useState(texts[0]);
  const [index, setIndex] = useState(0);
  const [animation, setAnimation] = useState("text-enter");

  useEffect(() => {
    const interval = setInterval(() => {
      setAnimation("text-exit");
      setTimeout(() => {
        setIndex((prevIndex) => (prevIndex + 1) % texts.length);
        setAnimation("text-enter");
      }, 500); // Still 0.5s for exit
    }, 5000); // Now 6s total cycle
  
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    setCurrentText(texts[index]);
  }, [index]);

  return (
    <div className={`me-2`}>
      <div className={` ${animation} `} key={currentText}>
        {currentText}
      </div>
    </div>
  );
};

export default RollingText1;
